export const emptyCv = () => ({
  full_name: "",
  title: "",
  personal_summary: "",
  nationality: "",
  location: "",
  age: "",
  languages: "",
  email: "",
  phone: "",
  photo_data_url: "",
  preset: { accent_color: "", tagline: "" },
  work_experience: [],
  previous_employment: [],
  education: [],
  certifications: [],
  competencies: [],
  career_highlights: [],
});

export const emptyRole = () => ({
  job_title: "",
  company: "",
  location: "",
  start_date: "",
  end_date: "",
  bullets: [],
});

export const emptyPrev = () => ({ role: "", company: "", years: "" });
export const emptyEdu = () => ({ qualification: "", institution: "", year: "" });
export const emptyCert = () => ({ name: "", issuer_year: "" });

export const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
